// extracted by mini-css-extract-plugin
export default {"container":"UserConsole_container__bzp5L","header":"UserConsole_header__DR3Tv","createUserButton":"UserConsole_createUserButton__PMweS","title":"UserConsole_title__jgM8J"};